// extracted by mini-css-extract-plugin
module.exports = {"error-page":"styles_error-page__2YsBf","error-msg":"styles_error-msg__3RIvA","error-msg__icon":"styles_error-msg__icon__2R3IO","error-btn":"styles_error-btn__Pu7z_"};